import {
  GET_PATIENTS,
  GET_SINGLE_PATIENT,
  ADD_PATIENT,
  EDIT_PATIENT,
  DELETE_PATIENT, CHANGE_STATUS_PATIENTS,
} from "./patients.types";

export const getPatients = (params, noLoad = false) => {
  return {
    type: GET_PATIENTS,
    payload: {
      params,
      noLoad
    },
  };
};

export const getSinglePatient = (id, noLoad = false) => {
  return {
    type: GET_SINGLE_PATIENT,
    payload: {
      id,
      noLoad
    },
  };
};

export const addPatient = (body) => {
  return {
    type: ADD_PATIENT,
    payload: {
      body,
    },
  };
};

export const editPatient = (id, body) => {
  return {
    type: EDIT_PATIENT,
    payload: {
      id,
      body,
    },
  };
};

export const deletePatient = (id) => {
  return {
    type: DELETE_PATIENT,
    payload: {
      id,
    },
  };
};

export const changeStatus = (id, body) => {
  return {
    type: CHANGE_STATUS_PATIENTS,
    payload: {
      id,
      body,
    },
  };
};
